module.exports = __webpack_public_path__ + "static/media/note-call-green.60f348e6.svg";